<template>
  <div>
    <div
      id="category-wrapper"
      :class="{'mobile-compact': isMobile && compactMode}"
      :style="mobileCompactStyle"
      v-if="currentCategory && currentCategory.type !== 'wfs_folder'"
    >
      <div id="category-header" v-if="currentCategory.parent">
        <button id="arrow" @click="chooseCategory(currentCategory.parent)">
          <i v-if="!$root.$data.embedded" class="material-icons-round">arrow_back_ios</i>
          {{ cleanCategoryName(currentCategory.name) }}
          <span v-if="collapsed && !$root.$data.embedded">({{ childCount(currentCategory) }})</span>
        </button>
        <div class="actions">
          <div v-if="canPinCurrent" class="pin" @click="togglePin(currentCategory)">
            <!-- <div v-if="hasItems && !$root.$data.embedded" class="pin" @click="togglePin(currentCategory)"> -->
            <i class="material-icons-round" :class="{pinned: isPinned}" title="pin">push_pin</i>
          </div>
          <div
            class="collapse"
            @click="
              collapsed = !collapsed;
              if (collapsed) overlayWanted = false;
              else if (isMobile && !compactMode) overlayWanted = true;
            "
          >
            <i class="material-icons-round" :class="{collapsed: collapsed}" title="collapse">keyboard_arrow_down</i>
          </div>
        </div>
      </div>

      <!-- <div id="chosen-category" v-if="pinnedCategories.length > 0"> -->
      <div id="chosen-category" v-if="pinnedCategories.length > 0 && !(isMobile && compactMode)">
        <div v-for="category in pinnedCategories" :key="category.id" class="chosen-single-cat">
          <div class="chosen-inner-cat">
            <div class="chosen-category-name">{{ cleanCategoryName(category.name) }} ({{ childCount(category) }})</div>
            <a class="close-button" @click="togglePin(category)" v-if="!$root.$data.embedded">Remove</a>
          </div>
        </div>
      </div>
      <div class="category-grid-wrapper" v-if="!collapsed">
        <EventsFrame v-if="showEventsFrame" @select-poi="goToPoi" />
        <!-- <EventsFrame
  v-if="showEventsFrame"
  @select-event="goToEvent"
/> -->

        <div
          v-if="!showEventsFrame"
          :class="[
            'category-grid',
            pinnedCategories.length > 0
              ? 'one-column'
              : currentCategory.parent
              ? 'one-column'
              : currentCategory.children.length <= 1
              ? 'one-column'
              : 'two-columns'
          ]"
        >
          <!-- <div :class="['category-grid', currentCategory.parent ? 'one-column' : 'two-columns']"> -->
          <div
            v-for="item in isMobile && compactMode ? visibleCompactCategories : compactItems"
            :key="item.id"
            class="category-container"
          >
            <button
              v-if="item.type === 'compact_pin'"
              class="category no-bg compact-pin-category"
              @click.stop="openPinnedCompact(item.pinnedCategory)"
            >
              <div class="category-box no-bg">
                <i class="material-icons-round pinned">push_pin</i>
              </div>
            </button>
            <div
              v-else-if="['folder', 'wfs_folder'].includes(item.type) && !$root.$data.embedded"
              class="category"
              @click="chooseCategory(item)"
              :style="getStyle(item)"
            >
              <!-- <img v-if="item.image" :src="hostAddress + item.image" alt="" /> -->
              <!-- <img v-else src="/images/placeholder.png" alt="" /> -->
              <!-- <img class="cover-logo" v-if="poiData.logo" :src="hostAddress + poiData.logo" alt="logo" /> -->
              <button
                v-if="['folder', 'wfs_folder'].includes(item.type) && !$root.$data.embedded"
                class="category no-bg"
                @click.stop="chooseCategory(item)"
                :style="getStyle(item)"
              >
                <div class="category-box no-bg">
                  <img v-if="item.logo" :src="hostAddress + item.logo" alt="" />
                  <div class="category-name" v-html="item.name" :lang="bcp47Locale"></div>
                </div>
              </button>

              <div class="category-box">
                <img v-if="item.logo" :src="hostAddress + item.logo" alt="" />
                <div class="category-name" v-html="item.name" :lang="bcp47Locale"></div>
              </div>
            </div>
            <PoiTocCard v-if="item.type === 'item' && item.name" :item="item" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="showMobileOverlay" class="mobile-cats-overlay" @click.stop @pointerdown.stop @touchstart.stop></div>
    <!-- <div
  v-if="showMobileOverlay"
  class="mobile-cats-overlay"
  @pointerdown.stop.prevent="compactMode = true; overlayWanted = false"
  @touchstart.stop.prevent="compactMode = true; overlayWanted = false"
></div> -->

    <WfsFolder
      v-if="currentCategory && currentCategory.type === 'wfs_folder'"
      :category="currentCategory"
      @return="handleReturnFromWfs"
    />
    <!-- 
    <WfsFolder
      v-if="currentCategory && currentCategory.type === 'wfs_folder'"
      v-bind:category="currentCategory"
      @return="chooseCategory(currentCategory.parent)"
    ></WfsFolder> -->
  </div>
</template>
<script>
import PoiTocCard from "./PoiTocCard";
import M2wApi from "@/services/m2w_api";
import WfsFolder from "@/components/category_components/WfsFolder";
import convertPoisToGeoJSON from "@/convertPoisToGeoJSON";
// import maplibregl from "maplibre-gl";
import {googleMaps} from "@/services/map/googleMaps";
import {basemap} from "@/services/map/basemap";
import EventsFrame from "@/components/events_components/EventsFrame.vue";
// import { hyphenateCategoryTree } from "@/translations/hyphenation";

export default {
  name: "CategoriesFrame",
  components: {WfsFolder, PoiTocCard, EventsFrame},
  data() {
    return {
      hostAddress: M2wApi.host_address,
      categoryTree: null,
      currentCategory: null,
      pinnedCategories: [],
      collapsed: this.$root.$data.embedded,
      compactMode: true,
      isMobile: false,
      overlayWanted: true,
      savedCatsUi: null,
      restoringCatsUi: false,
      ignoreHasTocIdUiSync: false,
      showEventsFrame: false
    };
  },

  async mounted() {
    await this.fetchFromApi();
    this.$root.$on("forceCategoryReloadFor3D", this.reloadCategoryFor3D);
    this.$root.$on("poiSelectedFrom3D", this.selectCategoryFrom3D);

    const mq = window.matchMedia("(max-width: 600px)");
    const set = () => (this.isMobile = mq.matches);
    set();
    if (this.isMobile && this.$route.query["toc-id"] && !this.$root.$data.embedded) {
      this.ensureCatsExpanded();
    }
    mq.addEventListener?.("change", set);
    this._mqCleanup = () => mq.removeEventListener?.("change", set);

    //---
    this._openCats = (opts = {}) => {
      if (!this.isMobile) return;

      this.compactMode = false;
      this.collapsed = false;

      if (typeof opts.forceOverlay === "boolean") {
        this.overlayWanted = opts.forceOverlay;
      } else {
        this.overlayWanted = opts.withOverlay !== false;
      }
    };

    this._catsToCompact = ({overlayOnNextOpen} = {}) => {
      if (!this.isMobile || this.$root.$data.embedded) return;

      this.compactMode = true;
      this.collapsed = false;
      this.overlayWanted = !!overlayOnNextOpen;
    };

    this.$root.$on("categoriesToCompact", this._catsToCompact);

    //-- pt setting

    // this._catsResetToInitial = async () => {
    //   if (!this.isMobile || this.$root.$data.embedded) return;
    //   if (!this.categoryTree) return;

    //   // ROOT + UI compact (starea din poza 1)
    //   this.currentCategory = this.categoryTree;
    //   this.compactMode = true;
    //   this.collapsed = false;
    //   this.overlayWanted = false;

    //   // optional: reîncarcă layerele pentru root, fără fly
    //   await this.$layers.setupCategory(this.categoryTree, this.goToPoi);
    //   this.emitPoisForMapsNoFly?.();

    //   this.$nextTick(() => this.updateBottomButtonsAnchor());
    // };

    // this.$root.$on("categoriesResetToInitial", this._catsResetToInitial);
    this.saveCatsUi = () => {
      if (!this.isMobile || this.$root.$data.embedded) return;

      this.savedCatsUi = {
        compactMode: this.compactMode,
        collapsed: this.collapsed,
        overlayWanted: this.overlayWanted,
        // opțional: dacă vrei și categoria curentă
        currentId: this.currentCategory?.id ?? null
      };
    };

    this.restoreCatsUi = () => {
      if (!this.isMobile || this.$root.$data.embedded) return;
      if (!this.savedCatsUi) return;

      this.ignoreHasTocIdUiSync = true;
      this.restoringCatsUi = true;

      this.compactMode = this.savedCatsUi.compactMode;
      this.collapsed = this.savedCatsUi.collapsed;
      this.overlayWanted = this.savedCatsUi.overlayWanted;

      if (this.savedCatsUi.currentId != null && this.categoryTree) {
        const cat = this.findCategory(this.categoryTree, Number(this.savedCatsUi.currentId));
        if (cat) this.currentCategory = cat;
      }

      this.savedCatsUi = null;

      this.$nextTick(() => {
        this.updateBottomButtonsAnchor();
        setTimeout(() => {
          this.restoringCatsUi = false;
          this.ignoreHasTocIdUiSync = false;
        }, 50);
      });
    };

    this.$root.$on("controlPopupOpened", this.saveCatsUi);
    this.$root.$on("controlPopupClosed", this.restoreCatsUi);
    // this._openCats = (opts = {}) => {
    //   if (!this.isMobile) return;

    // this.compactMode = false;
    // this.collapsed = false;

    // // implicit: cu overlay (click user)
    // // dar dacă vine din routing: opts.withOverlay = false
    // this.overlayWanted = opts.withOverlay !== false;
    // };
    this.$root.$on("openCategoriesMenu", this._openCats);

    window.addEventListener("resize", this.updateBottomButtonsAnchor, {passive: true});
    this.updateBottomButtonsAnchor();
  },
  activated() {
    if (this.categoryTree) {
      this.onActivated();
    }
    if (this.isMobile && this.$route.query["toc-id"] && !this.$root.$data.embedded) {
      this.ensureCatsExpanded();
    }

    if (this.isMobile && !this.$route.query["toc-id"]) {
      this.compactMode = true;
      this.overlayWanted = false;
      this.collapsed = false; // important
    }
    this.$nextTick(() => this.updateBottomButtonsAnchor());
  },
  // deactivated() {
  //   if (this.currentCategory) this.$layers.teardownCategory(this.currentCategory);
  //   for (let cat of this.pinnedCategories) this.$layers.teardownCategory(cat);
  // },

  deactivated() {
    if (this.currentCategory) {
      const curIsPinned = this.pinnedCategories.some(c => String(c.id) === String(this.currentCategory.id));
      if (!curIsPinned) this.$layers.teardownCategory(this.currentCategory);
    }
  },

  beforeDestroy() {
    this.$root.$off("forceCategoryReloadFor3D", this.reloadCategoryFor3D);
    this.$root.$off("poiSelectedFrom3D", this.selectCategoryFrom3D);
    this._mqCleanup?.();
    this.$root.$off("openCategoriesMenu", this._openCats);
    document.body.classList.remove("cats-overlay-on");
    document.body.classList.remove("cats-has-toc", "cats-no-toc");
    document.body.classList.remove("cats-has-toc", "cats-no-toc", "cats-collapsed");
    window.removeEventListener("resize", this.updateBottomButtonsAnchor);
    this.$root.$off("categoriesToCompact", this._catsToCompact);

    this.$root.$off("controlPopupOpened", this.saveCatsUi);
    this.$root.$off("controlPopupClosed", this.restoreCatsUi);
  },

  computed: {
    compactItems() {
      const normalItems = [...(this.currentCategory.children || []), ...(this.pinnedChildren || [])];

      if (!this.isMobile || !this.compactMode || this.pinnedCategories.length === 0) {
        return normalItems;
      }

      return [
        {
          id: "compact-pin",
          type: "compact_pin",
          pinnedCategory: this.pinnedCategories[0]
        },
        ...normalItems
      ];
    },
    bcp47Locale() {
      const map = {en: "en-US", de: "de", hu: "hu", ro: "ro"};
      return map[this.$i18n.locale] || "en-US";
    },

    pinnedChildren: function() {
      let distinctChildren = this.distinct(
        this.pinnedCategories
          .map(cat => cat.children)
          .flat()
          .filter(child => child.type === "item"),
        item => item.id
      );
      return distinctChildren.filter(c => !this.currentCategory.children.find(cc => c.id === cc.id));
    },
    hasItems: function() {
      return this.currentCategory.children.some(child => child.type === "item");
    },
    isPinned: function() {
      return this.pinnedCategories.includes(this.currentCategory);
    },
    canPinCurrent() {
      return !this.$root.$data.embedded && !!this.currentCategory?.parent;
    },
    showMobileOverlay() {
      const tocId = this.$route?.query?.["toc-id"];
      const hasToc = tocId != null && String(tocId).trim() !== "";

      return (
        this.isMobile &&
        hasToc &&
        !this.compactMode &&
        !this.collapsed &&
        this.overlayWanted &&
        !this.$root.$data.embedded
      );

      //  showMobileOverlay() {
      //   return (
      //     this.isMobile &&
      //     !this.compactMode &&
      //     !this.collapsed &&
      //     this.overlayWanted &&
      //     !this.$root.$data.embedded
      //   );
    },
    keepCatsExpanded() {
      return (
        this.isMobile && !this.$root.$data.embedded && !!this.$route.query["toc-id"] // ✅ cât timp avem toc-id
      );
    },
    catsExpanded() {
      return this.isMobile && !this.compactMode && !this.collapsed && !this.$root.$data.embedded;
    },
    catsCssVars() {
      if (!this.isMobile) return {};
      // dacă ai alte dimensiuni, le schimbi aici o singură dată
      return {
        "--cats-left": "12px",
        "--cats-w": this.compactMode ? "43px" : "350px",
        "--cats-gap": "10px"
      };
    },
    tocId() {
      return this.$route && this.$route.query ? this.$route.query["toc-id"] : null;
    },
    hasTocId() {
      return this.tocId != null && String(this.tocId).trim() !== "";
    },

    // visibleCompactCategories() {
    //   if (!this.isMobile || !this.compactMode || !this.currentCategory) return [];

    //   return [...(this.currentCategory.children || []), ...(this.pinnedChildren || [])].filter((item) =>
    //     ["folder", "wfs_folder"].includes(item.type)
    //   );
    // },
    visibleCompactCategories() {
      if (!this.isMobile || !this.compactMode || !this.currentCategory) return [];

      return this.compactItems.filter(
        item => item.type === "compact_pin" || ["folder", "wfs_folder"].includes(item.type)
      );
    },
    // visibleCompactCount() {
    //   return Math.min(this.visibleCompactCategories.length, 4);
    // },
    visibleCompactCount() {
      return Math.min(this.visibleCompactCategories.length, this.pinnedCategories.length > 0 ? 4 : 4);
    },

    mobileCompactStyle() {
      if (!this.isMobile || !this.compactMode) return {};

      const count = this.visibleCompactCount;

      if (count <= 0) return {};

      const itemHeight = 43;
      const gap = 4;
      const paddingTop = 2;
      const paddingBottom = 2;

      const totalHeight = count * itemHeight + Math.max(count - 1, 0) * gap + paddingTop + paddingBottom;

      return {
        maxHeight: `${totalHeight}px`
      };
    }
  },
  watch: {
    "$route.query['toc-id']": {
      immediate: true,
      handler(newVal) {
        if (this.$root.$data.embedded) return;

        if (!this.categoryTree) return;

        const has = newVal != null && String(newVal).trim() !== "";
        if (!has) {
          this.resetToRootFromUrlBack();
        }
      }
    },
    pinnedCategories: async function(newValues, oldValues) {
      for (let cat of newValues) {
        if (!oldValues.includes(cat)) {
          await this.$layers.setupCategory(cat, this.goToPoi);
        }
      }
      const queryValue = newValues.map(c => c.id).join(",");
      if (this.$route.query.pinned !== queryValue) {
        // await this.$router.push({ query: { ...this.$route.query, pinned: queryValue } });
        await this.$router.replace({query: {...this.$route.query, pinned: queryValue}});
      }
    },

    "$i18n.locale": async function() {
      await this.fetchFromApi();
    },

    showMobileOverlay: {
      immediate: true,
      handler(v) {
        document.body.classList.toggle("cats-overlay-on", !!v);
      }
    },

    hasTocId: {
      immediate: true,
      handler(has) {
        if (this.restoringCatsUi) {
          // doar body classes, fără să forțezi compact/expanded
          document.body.classList.toggle("cats-has-toc", has);
          document.body.classList.toggle("cats-no-toc", !has);
          this.$nextTick(() => this.updateBottomButtonsAnchor());
          return;
        }
        document.body.classList.toggle("cats-has-toc", has);
        document.body.classList.toggle("cats-no-toc", !has);

        if (!this.isMobile || this.$root.$data.embedded) {
          this.updateBottomButtonsAnchor();
          return;
        }

        if (has) {
          this.compactMode = false;
          this.collapsed = false;
          this.overlayWanted = true; //  overlay ON
        } else {
          this.compactMode = true;
          this.overlayWanted = false; //  overlay OFF
        }

        this.$nextTick(() => this.updateBottomButtonsAnchor());
      }
    },

    collapsed: {
      immediate: true,
      handler(v) {
        document.body.classList.toggle("cats-collapsed", !!v);
        this.updateBottomButtonsAnchor();
      }
    },

    compactMode() {
      this.updateBottomButtonsAnchor();
    },

    isMobile() {
      this.updateBottomButtonsAnchor();
    },

    catsExpanded: {
      immediate: true,
      handler(v) {
        document.body.classList.toggle("cats-expanded", !!v);
        document.body.classList.toggle("cats-compact", !v);
        this.updateBottomButtonsAnchor();
      }
    }
  },

  //   watch: {
  //     hasTocId: {
  //     immediate: true,
  //     handler(has) {
  //       document.body.classList.toggle("cats-has-toc", has);
  //       document.body.classList.toggle("cats-no-toc", !has);
  //     }
  //   },

  //   collapsed: {
  //     immediate: true,
  //     handler(v) {
  //       document.body.classList.toggle("cats-collapsed", !!v);
  //     }
  //   },
  //     pinnedCategories: async function (newValues, oldValues) {
  //       for (let cat of newValues) {
  //         if (!oldValues.includes(cat)) {
  //           await this.$layers.setupCategory(cat, this.goToPoi);
  //         }
  //       }
  //       const queryValue = newValues.map(c => c.id).join(',');
  //       if (this.$route.query.pinned !== queryValue) {
  //         await this.$router.push({ query: { ...this.$route.query, pinned: queryValue } });
  //       }
  //     },

  //     "$i18n.locale": async function () {
  //       await this.fetchFromApi();
  //     },
  //     showMobileOverlay: {
  //     immediate: true,
  //     handler(v) {
  //       document.body.classList.toggle("cats-overlay-on", !!v);
  //     }

  //   },
  //   compactMode(v) { console.log('[CategoriesFrame] compactMode ->', v, new Error().stack);if (v === true) console.trace('[compactMode set TRUE trace]'); },
  // // "$route.name": {
  // //     immediate: true,
  // //     handler(name) {
  // //       // pune aici numele real al rutei tale de hartă
  // //       if (name === "map") {
  // //         this.ensureCatsExpanded();
  // //       }
  // //     }},
  //     keepCatsExpanded: {
  //     immediate: true,
  //     handler(v) {
  //       if (!this.isMobile || this.$root.$data.embedded) return;

  //       if (v) {

  //         this.compactMode = false;
  //         this.collapsed = false;
  //         this.overlayWanted = true;
  //       } else {

  //         this.compactMode = true;
  //         this.overlayWanted = false;
  //       }
  //     }
  //   },
  //   // "$route.query['toc-id']": {
  //   //   immediate: true,
  //   //   handler(tocId) {
  //   //     const hasToc = tocId != null && String(tocId).trim() !== "";

  //   //     document.body.classList.toggle("cats-has-toc", hasToc);
  //   //     document.body.classList.toggle("cats-no-toc", !hasToc);
  //   //   }
  //   // },
  //   //  "$route.query.toc-id": {
  //   //   immediate: true,
  //   //   handler(tocId) {
  //   //     if (!this.isMobile || this.$root.$data.embedded) return;

  //   //     if (tocId) {
  //   //       // avem toc-id => vrem meniul deschis
  //   //       this.compactMode = false;
  //   //       this.collapsed = false;
  //   //       this.overlayWanted = false; // ca să nu ascunzi butoane inutil (opțional)
  //   //     }
  //   //   }
  //   // },
  //   catsExpanded: {
  //     immediate: true,
  //     handler(v) {
  //       document.body.classList.toggle("cats-expanded", !!v);
  //       document.body.classList.toggle("cats-compact", !v); // util pt reguli inverse
  //     }
  //   },
  //   hasTocId: {
  //     immediate: true,
  //     handler(has) {
  //       document.body.classList.toggle("cats-has-toc", has);
  //       document.body.classList.toggle("cats-no-toc", !has);
  //       this.updateBottomButtonsAnchor();
  //     }
  //   },

  //   collapsed: {
  //     immediate: true,
  //     handler(v) {
  //       document.body.classList.toggle("cats-collapsed", !!v);
  //       this.updateBottomButtonsAnchor();
  //     }
  //   },

  //   compactMode() {
  //     this.updateBottomButtonsAnchor();
  //   },

  //   isMobile() {
  //     this.updateBottomButtonsAnchor();
  //   },

  //   },

  methods: {
    async goToEvent(payload) {
      const {eventId, poiId, parentId, poi} = payload;

      if (!poi?.geom) return;

      // doar afișare pe hartă, fără PoiDetails
      this.$root.$emit("poiSelectedFromList", {
        type: "Feature",
        geometry: poi.geom,
        properties: {
          ...poi,
          id: poi.id,
          name: poi.name,
          short_info: poi.short_info,
          url_360: poi.url_360,
          parent_id: parentId,
          icon: poi.marker || poi.icon || poi.logo
        }
      });

      // deschide EventDetails
      await this.$router
        .push({
          name: "eventDetails",
          params: {
            id: String(eventId)
          },
          query: {
            poi_id: String(poiId),
            parent: String(parentId)
          }
        })
        .catch(error => {
          if (error?.name !== "NavigationDuplicated") {
            console.error(error);
          }
        });
    },
    openPinnedCompact(category) {
      if (!category) return;

      this.compactMode = false;
      this.collapsed = false;
      this.overlayWanted = true;

      this.chooseCategory(category);
    },
    async resetToRootFromUrlBack() {
      if (!this.categoryTree) return;

      const old = this.currentCategory;
      this.currentCategory = this.categoryTree;

      if (this.isMobile) {
        this.compactMode = true;
        this.overlayWanted = false;
        this.collapsed = false;
      }

      // reset layere/POI
      try {
        if (old && !this.pinnedCategories.includes(old)) {
          this.$layers.teardownCategory(old);
        }
        await this.$layers.setupCategory(this.categoryTree, this.goToPoi);
        this.emitPoisForMapsNoFly();
        // this.emitPoisForMaps();
      } catch (e) {
        console.warn("[CategoriesFrame] resetToRootFromUrlBack failed:", e);
      }

      this.$nextTick(() => this.updateBottomButtonsAnchor());
    },

    updateBottomButtonsAnchor() {
      if (!this.isMobile) return;

      this.$nextTick(() => {
        const el = document.getElementById("category-wrapper");
        if (!el) return;

        const r = el.getBoundingClientRect();
        const root = document.documentElement; // :root

        root.style.setProperty("--cats-bottom", `${Math.round(r.bottom)}px`);
        root.style.setProperty("--cats-left", `${Math.round(r.left)}px`);
        root.style.setProperty("--cats-w", `${Math.round(r.width)}px`);
      });
    },

    ensureCatsExpanded() {
      if (!this.isMobile) return;
      if (this.$root.$data.embedded) return;
      this.compactMode = false;
      this.collapsed = false;
      this.overlayWanted = true;
    },

    cleanCategoryName(name) {
      if (!name) return "";
      return name.replace(/&shy;|\u00AD/g, "");
    },
    isService(cat) {
      return cat && cat.type !== "wfs_folder" && (!Array.isArray(cat.children) || cat.children.length === 0);
    },
    findItemById(node, idWanted) {
      if (!node) return null;
      const want = String(idWanted);
      if (String(node.id) === want) return node;
      if (Array.isArray(node.children)) {
        for (const ch of node.children) {
          const hit = this.findItemById(ch, want);
          if (hit) return hit;
        }
      }
      return null;
    },
    async selectCategoryFrom3D(feature) {
      const TAG = "[CategoriesFrame] selectCategoryFrom3D";
      console.groupCollapsed(`${TAG} ▶ start`);
      try {
        console.log(`${TAG} raw feature:`, feature);
        const g = feature?.geometry;
        console.log(`${TAG} geom:`, {
          type: g?.type,
          hasCoords: !!g?.coordinates,
          coordsLen: Array.isArray(g?.coordinates)
            ? g.coordinates.length
            : Array.isArray(g?.coordinates?.[0])
            ? g.coordinates[0].length
            : undefined
        });
        console.log(`${TAG} properties(keys):`, Object.keys(feature?.properties || {}));
        const rawId = feature?.properties?.id ?? feature?.id ?? "";
        const id = String(rawId || "");
        console.log(`${TAG} extracted id:`, {rawId, id, typeofRawId: typeof rawId});
        if (!id) {
          console.warn(`${TAG} Fără id pe feature → ies`);
          console.groupEnd();
          return;
        }

        const item = this.findItemById(this.categoryTree, id);
        console.log(`${TAG} item găsit în categoryTree:`, item);
        const parentCandidates = {
          fromItem: item?.parent?.id ?? null,
          fromFeatureProp: feature?.properties?.parent_id ?? null,
          fromCurrentCategory: this.currentCategory?.id ?? null,
          fromRouteQuery: this.$route?.query?.parent ?? null
        };
        const parentId =
          parentCandidates.fromItem ??
          parentCandidates.fromFeatureProp ??
          parentCandidates.fromCurrentCategory ??
          parentCandidates.fromRouteQuery ??
          null;

        console.log(`${TAG} parent candidates:`, parentCandidates);
        console.log(`${TAG} parentId ales:`, parentId);

        const target = {
          name: "poiDetails",
          params: {id},
          query: {...this.$route.query, parent: parentId}
        };
        console.log(`${TAG} target route:`, target);
        console.log(`${TAG} current route:`, {
          name: this.$route.name,
          params: this.$route.params,
          query: this.$route.query
        });

        const samePage =
          this.$route.name === target.name &&
          String(this.$route.params.id ?? "") === String(target.params.id ?? "") &&
          String(this.$route.query.parent ?? "") === String(target.query.parent ?? "");
        console.log(`${TAG} samePage?`, samePage);

        if (!samePage) {
          try {
            await this.$router.push(target);
            console.log(`${TAG} router.push OK`);
          } catch (err) {
            if (err?.name === "NavigationDuplicated") {
              console.log(`${TAG} router.push NavigationDuplicated (ignorat)`);
            } else {
              console.warn(`${TAG} router.push error:`, err);
            }
          }
        } else {
          console.log(`${TAG} suntem deja pe ruta țintă → nu navighez`);
        }

        // this.$root.$refs.weatherMtk?.focusOnPoi?.(feature);
      } catch (e) {
        console.warn(`${TAG} failed:`, e);
      } finally {
        console.groupEnd();
      }
    },
    categoryHasPois(cat) {
      if (!cat || !Array.isArray(cat.children)) return false;
      return cat.children.some(el => {
        const geom = typeof el.geom === "function" ? el.geom() : el.geom;
        const coords = geom?.coordinates || (Array.isArray(geom) ? geom : null);
        return Array.isArray(coords) && coords.length > 0;
      });
    },

    restoreInitialMapView() {
      try {
        const saved = sessionStorage.getItem("initialView");
        if (!saved) return;
        const {lat, lng, zoom} = JSON.parse(saved);

        const view = basemap.map.getView();
        view.setCenter(googleMaps.transformFromLatLng({lat, lng}));
        if (typeof zoom === "number") view.setZoom(zoom);
      } catch (e) {
        console.warn("[CategoriesFrame] initialView invalid:", e);
        sessionStorage.removeItem("initialView");
      }
    },
    async handleReturnFromWfs() {
      const parent = this.currentCategory?.parent;
      if (!parent) return;

      const goingToRoot = !parent.parent;
      console.log(goingToRoot, "layers Cristina");

      await this.chooseCategory(parent);

      if (goingToRoot) {
        this.restoreInitialMapView();
      }
    },
    async fetchFromApi() {
      this.$Progress.start();
      const data = await M2wApi.get_project_pois(this.$i18n.locale);
      this.categoryTree = data;
      this.linkChildren(this.categoryTree);
      await this.onActivated();
      this.$Progress.finish();
    },
    async chooseCategory(category) {
      console.log("CATEGORY:", category);
      if (this.$root.$data.embedded) return;

      const rawName = typeof category.name === "string" ? category.name : category.name?.name || "";

      const categoryName = rawName
        .replace(/&shy;|\u00AD/g, "")
        .trim()
        .toLowerCase();

      const isEventsCalendar = [
        "calendar evenimente",
        "events calendar",
        "veranstaltungskalender",
        "eseménynaptár",
        "events",
        "evenimente"
      ].includes(categoryName);

      if (isEventsCalendar) {
        console.log("[Calendar evenimente] category clicked:", category);

        this.showEventsFrame = true;

        await this.updateCurrentCategory(category, this.currentCategory);

        return;
      }

      this.showEventsFrame = false;

      const goingToRoot = !category?.parent;

      if (this.isMobile && !goingToRoot) {
        this.overlayWanted = true;
      }

      if (this.isMobile && this.compactMode) {
        this.compactMode = false;
      }

      this.collapsed = false;

      if (category?.name && category.name.includes("href=")) {
        const href = category.name.match(/href="(.+?)"/)?.[1];
        if (href) window.open(href);
        return;
      }

      if (this.isService(category)) {
        if (!this.pinnedCategories.some(c => String(c.id) === String(category.id))) {
          this.$root.$emit("armClose3D");
          this.$root.$emit("armServiceForCategory", {catId: category.id});
          this.togglePin(category);
        }
        return;
      }

      await this.updateCurrentCategory(category, this.currentCategory);

      if (goingToRoot) {
        this.restoreInitialMapView();
        this.$root.$emit("clearAll3D");
      }
    },
    async chooseCategorys(category) {
      console.log("CATEGORY:", category);
      if (this.$root.$data.embedded) return;

      // Events Calendar
      if (
        category.name === "Calendar evenimente" ||
        category.name === "Events Calendar" ||
        category.name === "Veranstaltungskalender" ||
        category.name === "Eseménynaptár"
      ) {
        console.log("[Calendar evenimente] category clicked:", category);

        const events = await M2wApi.get_project_events(this.$i18n.locale);

        console.log("[Calendar evenimente] events:", events);
        console.log("[Calendar evenimente] total:", events.length);

        await this.$router.push({
          name: "events",
          query: {
            ...this.$route.query,
            "toc-id": category.id
          }
        });

        return;
      }

      const goingToRoot = !category?.parent;

      if (this.isMobile && !goingToRoot) {
        this.overlayWanted = true;
      }
      if (this.isMobile && this.compactMode) {
        this.compactMode = false;
      }
      if (this.isMobile && goingToRoot) {
        // this.compactMode = true;
        // this.overlayWanted = false;
      }

      this.collapsed = false;

      if (category?.name && category.name.includes("href=")) {
        const href = category.name.match(/href="(.+?)"/)?.[1];
        if (href) window.open(href);
        return;
      }

      if (this.isService(category)) {
        if (!this.pinnedCategories.some(c => String(c.id) === String(category.id))) {
          this.$root.$emit("armClose3D");
          this.$root.$emit("armServiceForCategory", {catId: category.id});
          this.togglePin(category);
        }
        return;
      }

      await this.updateCurrentCategory(category, this.currentCategory);

      if (goingToRoot) {
        this.restoreInitialMapView();
        this.$root.$emit("clearAll3D");
      }
    },

    // async updateCurrentCategory(category, oldCategory) {
    //   if (this.$root.showMap3D && this.$root.$refs.map3d?.getCurrentView) {
    //     this.savedCamera3D = this.$root.$refs.map3d.getCurrentView();
    //   }
    //   this.currentCategory = category;

    //   if (oldCategory && !this.pinnedCategories.includes(oldCategory)) {
    //     this.$layers.teardownCategory(oldCategory);
    //   }
    //   const rawChildren = category.children || [];
    //   console.log(rawChildren);

    //   const pois = rawChildren
    //     .map((el) => {
    //       const geom = typeof el.geom === "function" ? el.geom() : el.geom;
    //       const coords = geom?.coordinates || (Array.isArray(geom) ? geom : null);

    //       if (!coords || !Array.isArray(coords)) return null;

    //       return {
    //         id: el.id,
    //         name: el.name,
    //         type: el.type,
    //         parent_id: el.parent?.id,
    //         geom: coords,
    //         height: el.height,
    //         style: el.style,
    //         icon: el.icon
    //           ? this.hostAddress + el.icon
    //           : el.marker
    //             ? this.hostAddress + el.marker
    //             : el.parent?.marker
    //               ? this.hostAddress + el.parent.marker
    //               : null,

    //         icon_id: el.icon
    //           ? el.icon.split("/").pop()
    //           : el.marker
    //             ? el.marker.split("/").pop()
    //             : el.parent?.marker
    //               ? el.parent.marker.split("/").pop()
    //               : null,

    //         width: el.width,
    //         color: el.color,
    //         line_color: el.line_color,
    //         line_thickness: el.line_thickness,
    //       };
    //     })
    //     .filter(Boolean);

    //   const willHavePois = pois.length > 0;
    //   if (!willHavePois) {
    //     console.log("[3D→OL] folder fără POI-uri → armClose3D");
    //     this.$root.$emit("armClose3D");
    //     this.$root.$emit('armServiceForCategory', { catId: category.id });
    //   }

    //   await this.$layers.setupCategory(category, this.goToPoi);
    //   // const geojsonPois = convertPoisToGeoJSON(pois);
    //   // console.log('[DB->MAP] geojsonPois ->', geojsonPois);
    //   // this.loadedFeatures = geojsonPois.features;
    //   // this.lastPoisJSON = JSON.stringify(geojsonPois);
    //   // this.$root.$emit("poisLoaded", geojsonPois);
    //   // console.log("Sending POIs to maps", geojsonPois);
    //   // this.$root.$emit("focusPois", geojsonPois);
    //   // console.log("Focus POIs to maps", geojsonPois);

    //   this.emitPoisForMaps();

    //   if (oldCategory && this.savedCamera3D && this.$root.weatherMtk) {
    //     this.$nextTick(() => {
    //       setTimeout(() => {
    //         console.log("Restoring previous 3D camera:", this.savedCamera3D);
    //         this.$root.$refs.weatherMtk.map.flyTo({
    //           center: [this.savedCamera3D.lng, this.savedCamera3D.lat],
    //           zoom: this.savedCamera3D.zoom,
    //           bearing: this.savedCamera3D.bearing || 0,
    //           pitch: this.savedCamera3D.pitch || 0,
    //           speed: 0.6,
    //           curve: 1.1,
    //         });
    //       }, 200);
    //     });
    //   }

    //   this.$emit("showHeader", category.name === null);
    //   if (!category.id && this.$route.query["toc-id"]) {
    //     const {["toc-id"]: _, ...filtered} = this.$route.query;
    //     await this.$router.push({query: filtered});
    //   }
    //   if (
    //     category.id &&
    //     (!this.$route.query["toc-id"] || this.$route.query["toc-id"].toString() !== category.id.toString())
    //   ) {
    //     await this.$router.push({query: {...this.$route.query, "toc-id": category.id}});
    //   }
    // },

    async updateCurrentCategory(category, oldCategory) {
      if (oldCategory) {
        const oldWasPinned = this.pinnedCategories.some(c => String(c.id) === String(oldCategory.id));

        const oldHadPois = this.categoryHasPois(oldCategory);

        if (!oldWasPinned && !oldHadPois && oldCategory.id != null) {
          console.log(
            "[CategoriesFrame] back din categorie fără POI-uri → deactivateServiceForCategory",
            oldCategory.id
          );
          this.$root.$emit("deactivateServiceForCategory", {cat: oldCategory});
        }
      }

      if (this.$root.showMap3D && this.$root.$refs.map3d?.getCurrentView) {
        this.savedCamera3D = this.$root.$refs.map3d.getCurrentView();
      }
      this.currentCategory = category;

      if (oldCategory && !this.pinnedCategories.includes(oldCategory)) {
        this.$layers.teardownCategory(oldCategory);
      }
      const rawChildren = category.children || [];
      console.log(rawChildren);

      const pois = rawChildren
        .map(el => {
          const geom = typeof el.geom === "function" ? el.geom() : el.geom;
          const coords = geom?.coordinates || (Array.isArray(geom) ? geom : null);

          if (!coords || !Array.isArray(coords)) return null;
          console.log("===== BEFORE BUILD POI =====");
          console.log("ID:", el.id);
          console.log("NAME:", el.name);
          console.log("EL:", el);
          console.log("el.short_info:", el.short_info);
          console.log("el.add_info:", el.add_info);
          console.log("el.contact:", el.contact);
          console.log("el.contact?.add_info:", el.contact?.add_info);
          return {
            id: el.id,
            name: el.name,
            type: el.type,
            parent_id: el.parent?.id,
            short_info: el.short_info || null,
            url_360: el.url_360 || null,
            add_info: el.add_info || el.contact?.add_info || null,
            geom: coords,
            height: el.height,
            style: el.style,
            icon: el.icon
              ? this.hostAddress + el.icon
              : el.marker
              ? this.hostAddress + el.marker
              : el.parent?.marker
              ? this.hostAddress + el.parent.marker
              : null,

            icon_id: el.icon
              ? el.icon.split("/").pop()
              : el.marker
              ? el.marker.split("/").pop()
              : el.parent?.marker
              ? el.parent.marker.split("/").pop()
              : null,

            width: el.width,
            color: el.color,
            line_color: el.line_color,
            line_thickness: el.line_thickness
          };
        })
        .filter(Boolean);

      const willHavePois = pois.length > 0;
      if (!willHavePois) {
        console.log("[3D→OL] folder fără POI-uri → armClose3D");
        this.$root.$emit("armClose3D");
        this.$root.$emit("armServiceForCategory", {catId: category.id});
      }

      await this.$layers.setupCategory(category, this.goToPoi);
      await this.emitPoisForMaps();

      // this.emitPoisForMaps();

      if (oldCategory && this.savedCamera3D && this.$root.weatherMtk) {
        this.$nextTick(() => {
          setTimeout(() => {
            console.log("Restoring previous 3D camera:", this.savedCamera3D);
            this.$root.$refs.weatherMtk.map.flyTo({
              center: [this.savedCamera3D.lng, this.savedCamera3D.lat],
              zoom: this.savedCamera3D.zoom,
              bearing: this.savedCamera3D.bearing || 0,
              pitch: this.savedCamera3D.pitch || 0,
              speed: 0.6,
              curve: 1.1
            });
          }, 200);
        });
      }

      this.$emit("showHeader", category.name === null);
      if (!category.id && this.$route.query["toc-id"]) {
        const {["toc-id"]: _, ...filtered} = this.$route.query;
        // await this.$router.push({ query: filtered });
        await this.$router.replace({query: filtered});
      }
      if (
        category.id &&
        (!this.$route.query["toc-id"] || this.$route.query["toc-id"].toString() !== category.id.toString())
      ) {
        // await this.$router.push({
        //   query: { ...this.$route.query, "toc-id": category.id },
        // });
        await this.$router.replace({
          query: {...this.$route.query, "toc-id": category.id}
        });
      }
    },

    async onActivated() {
      this.currentCategory = this.findCurrentCategory();
      await this.updateCurrentCategory(this.currentCategory, null);

      this.pinnedCategories = this.findPinnedCategories();
    },

    //     buildPoisFromCategories(categories) {
    //       const rawChildren = categories
    //         .filter(Boolean)
    //         .map((cat) => cat.children || [])
    //         .flat();

    //       const pois = rawChildren
    //         .map((el) => {
    //           const geomObj = typeof el.geom === "function" ? el.geom() : el.geom;

    //           if (!geomObj || !geomObj.type || !geomObj.coordinates) return null;
    //           // const geom = typeof el.geom === "function" ? el.geom() : el.geom;
    //           // const coords = geom?.coordinates || (Array.isArray(geom) ? geom : null);

    //           // if (!coords || !Array.isArray(coords)) return null;

    //           return {
    //             id: el.id,
    //             name: el.name,
    //             type: el.type,
    //             parent_id: el.parent?.id,
    //             short_info: el.short_info || null,
    // add_info: el.add_info || el.contact?.add_info || null,
    //             // geom: coords,
    //             geom: {
    //               type: geomObj.type,
    //               coordinates: geomObj.coordinates,
    //             },
    //             height: el.height,
    //             style: el.style,
    //             icon: el.icon
    //               ? this.hostAddress + el.icon
    //               : el.marker
    //               ? this.hostAddress + el.marker
    //               : el.parent?.marker
    //               ? this.hostAddress + el.parent.marker
    //               : null,

    //             icon_id: el.icon
    //               ? el.icon.split("/").pop()
    //               : el.marker
    //               ? el.marker.split("/").pop()
    //               : el.parent?.marker
    //               ? el.parent.marker.split("/").pop()
    //               : null,

    //             width: el.width,
    //             color: el.color,
    //             line_color: el.line_color,
    //             line_thickness: el.line_thickness,
    //           };
    //         })
    //         .filter(Boolean);
    //       const seen = new Set();
    //       return pois.filter((p) => {
    //         if (seen.has(p.id)) return false;
    //         seen.add(p.id);
    //         return true;
    //       });
    //     },
    async buildPoisFromCategories(categories) {
      const rawChildren = categories
        .filter(Boolean)
        .map(cat => cat.children || [])
        .flat();

      const pois = await Promise.all(
        rawChildren.map(async el => {
          const geomObj = typeof el.geom === "function" ? el.geom() : el.geom;

          if (!geomObj || !geomObj.type || !geomObj.coordinates) {
            return null;
          }

          let fullPoi = null;

          try {
            fullPoi = await M2wApi.get_single_poi(el.id, this.$i18n.locale, el.parent?.id);
          } catch (error) {
            console.warn("[CategoriesFrame] get_single_poi failed:", el.id, error);
          }

          // AICI
          console.log("[FULL POI PANORAMA]", {
            requestedId: el.id,
            returnedId: fullPoi?.id,
            requestedName: el.name,
            returnedName: fullPoi?.name,
            url_360: fullPoi?.url_360
          });

          return {
            id: el.id,
            name: el.name,
            type: el.type,
            parent_id: el.parent?.id,

            url_360: fullPoi?.url_360 || null,

            geom: {
              type: geomObj.type,
              coordinates: geomObj.coordinates
            },

            height: el.height,
            style: el.style,

            icon: el.icon
              ? this.hostAddress + el.icon
              : el.marker
              ? this.hostAddress + el.marker
              : el.parent?.marker
              ? this.hostAddress + el.parent.marker
              : null,

            icon_id: el.icon
              ? el.icon.split("/").pop()
              : el.marker
              ? el.marker.split("/").pop()
              : el.parent?.marker
              ? el.parent.marker.split("/").pop()
              : null,

            width: el.width,
            color: el.color,
            line_color: el.line_color,
            line_thickness: el.line_thickness
          };
        })
      );

      const seen = new Set();

      return pois.filter(Boolean).filter(p => {
        if (seen.has(p.id)) return false;
        seen.add(p.id);
        return true;
      });
    },
    async emitPoisForMaps() {
      const categories = [this.currentCategory, ...this.pinnedCategories];

      const pois = await this.buildPoisFromCategories(categories);

      const geojsonPois = convertPoisToGeoJSON(pois);

      console.log("[DB->MAP] geojsonPois (all cats+pins) ->", geojsonPois);

      this.loadedFeatures = geojsonPois.features;
      this.lastPoisJSON = JSON.stringify(geojsonPois);

      this.$root.$emit("poisLoaded", geojsonPois);

      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.$root.$emit("focusPois", geojsonPois);
        });
      });
    },
    //     emitPoisForMaps() {
    //       const categories = [this.currentCategory, ...this.pinnedCategories];

    //       const pois = this.buildPoisFromCategories(categories);
    //       const geojsonPois = convertPoisToGeoJSON(pois);

    //       console.log("[DB->MAP] geojsonPois (all cats+pins) ->", geojsonPois);
    //       this.loadedFeatures = geojsonPois.features;
    //       this.lastPoisJSON = JSON.stringify(geojsonPois);

    //       // this.$root.$emit("poisLoaded", geojsonPois);
    //       // this.$root.$emit("focusPois", geojsonPois);
    //       this.$root.$emit("poisLoaded", geojsonPois);

    // this.$nextTick(() => {
    //   requestAnimationFrame(() => {
    //     this.$root.$emit("focusPois", geojsonPois);
    //   });
    // });
    //     },
    emitPoisForMapsNoFly() {
      const categories = [this.currentCategory, ...this.pinnedCategories];

      const pois = this.buildPoisFromCategories(categories);
      const geojsonPois = convertPoisToGeoJSON(pois);

      console.log("[DB->MAP] geojsonPois (all cats+pins) ->", geojsonPois);
      this.loadedFeatures = geojsonPois.features;
      this.lastPoisJSON = JSON.stringify(geojsonPois);

      this.$root.$emit("poisLoaded", geojsonPois);
    },

    togglePin(category) {
      const wasPinned = this.pinnedCategories.some(c => String(c.id) === String(category.id));

      if (wasPinned) {
        // REMOVE
        this.pinnedCategories = this.pinnedCategories.filter(c => String(c.id) !== String(category.id));
        this.$layers.teardownCategory(category);
        this.$root.$emit("deactivateServiceForCategory", {cat: category});
        if (this.currentCategory?.id === category.id && category.parent) {
          this.chooseCategory(category.parent);
        }
      } else {
        // ADD
        if (this.isService(category)) {
          this.$root.$emit("armClose3D");
          this.$root.$emit("armServiceForCategory", {catId: category.id});
        }
        this.pinnedCategories = [...this.pinnedCategories, category];
        this.$layers.setupCategory(category, this.goToPoi);
      }

      this.emitPoisForMapsNoFly();
    },

    // togglePin(category) {
    //   const wasPinned = this.pinnedCategories.some(c => String(c.id) === String(category.id));

    //   if (wasPinned) {
    //     // REMOVE
    //     this.pinnedCategories = this.pinnedCategories.filter(c => String(c.id) !== String(category.id));
    //     this.$layers.teardownCategory(category);
    //     this.$root.$emit('deactivateServiceForCategory', { cat: category });
    //     if (this.currentCategory?.id === category.id && category.parent) this.chooseCategory(category.parent);
    //   } else {
    //     // ADD
    //     if (this.isService(category)) {
    //       this.$root.$emit('armClose3D');
    //       this.$root.$emit('armServiceForCategory', { catId: category.id });
    //     }
    //     this.pinnedCategories = [...this.pinnedCategories, category];
    //     this.$layers.setupCategory(category, this.goToPoi);
    //   }
    // },

    linkChildren(category) {
      if (category.children) {
        for (let child of category.children) {
          child["parent"] = category;
          this.linkChildren(child);
        }
      }
    },

    findCurrentCategory() {
      let catId = this.$route.query["toc-id"];
      if (catId && !isNaN(catId)) {
        let cat = this.findCategory(this.categoryTree, parseInt(catId));
        if (cat) return cat;
      }
      return this.categoryTree;
    },

    findCategory(node, catId) {
      if (node.id === catId) return node;
      if (node.children) {
        for (let child of node.children) {
          let hit = this.findCategory(child, catId);
          if (hit) return hit;
        }
      }
      return null;
    },

    findPinnedCategories() {
      let catIds = this.$route.query["pinned"];
      if (!catIds) return [];

      let split = catIds.split(",");
      return split
        .map(chunk => chunk.trim())
        .filter(chunk => !isNaN(chunk))
        .map(chunk => parseInt(chunk))
        .filter((v, i, a) => a.indexOf(v) === i) // distinct
        .map(id => this.findCategory(this.categoryTree, id));
    },

    distinct(arr, func) {
      let tmp = {};
      return arr.filter(function(entry) {
        let key = func(entry);
        if (tmp[key]) {
          return false;
        }
        tmp[key] = true;
        return true;
      });
    },

    async goToPoiinitial(poi) {
      if (poi.name)
        // ex. bus lines should not be clickable
        await this.$router.push({
          name: "poiDetails",
          params: {id: poi.id},
          query: {...this.$route.query, parent: poi.parent.id}
        });
      console.log("goTOPOI cand dau click pe harta ol se aplica ");
      console.log("SINGLE POI", poi);
      console.log("width", poi.width);
      console.log("line_thickness", poi.line_thickness);
      console.log("style", poi.style);
      console.log("properties", poi.properties);
      // if (!poi?.geom) return;
    },
    async goToPoi(poi) {
      if (!poi) return;

      const poiId = poi.poiId ?? poi.id;

      const parentId = poi.parentId ?? poi.parent?.id ?? poi.parent_id;

      try {
        // if (poi.fromEvent === true) {
        //   const poiForMap = {
        //     ...poi,
        //     id: poiId,
        //     parent: {
        //       ...(poi.parent || {}),
        //       id: parentId,
        //     },
        //   };

        //   // Selectează POI-ul pe harta 2D prin logica existentă
        //   await this.$layers.setupSinglePoi(poiForMap);

        //   // Trimite POI-ul și către harta 3D
        //   this.$root.$emit("poiSelectedFromList", {
        //     type: "Feature",
        //     geometry: poi.geom,
        //     properties: {
        //       ...poi,
        //       id: poiId,
        //       name: poi.name,
        //       parent_id: parentId,
        //       icon: poi.marker || poi.icon || poi.logo,
        //     },
        //   });

        //   // Deschide detaliile evenimentului
        //   await this.$router.push({
        //     name: "eventDetails",
        //     params: {
        //       id: String(poi.eventId),
        //     },
        //     query: {
        //       ...this.$route.query,
        //       poi_id: String(poiId),
        //       parent: String(parentId),
        //     },
        //   });

        //   return;
        // }

        if (poi.fromEvent === true) {
          const poiData = await M2wApi.get_single_poi(poiId, this.$i18n.locale, parentId);

          // Adaugă POI-ul și primește extinderea geometriei
          const extent = await this.$layers.setupSinglePoi(poiData);

          // Centrare pe harta 2D
          if (extent) {
            basemap.map.getView().fit(extent, {
              duration: 500,
              minResolution: 1,
              maxZoom: 17,
              padding: [40, 40, 40, 40]
            });
          }

          // Transmite punctul către harta 3D
          this.$root.$emit("poiSelectedFromList", {
            type: "Feature",
            geometry: poiData.geom,
            properties: {
              ...poiData,
              id: poiData.id,
              name: poiData.name,
              parent_id: parentId,
              short_info: poiData.short_info,
              url_360: poiData.url_360,
              icon: poiData.marker || poiData.icon || poiData.logo
            }
          });

          // Centrare pe harta 3D
          this.$root.$emit("focusMapAfterAdding", poiData);

          // Deschide EventDetails, nu PoiDetails
          await this.$router.push({
            name: "eventDetails",
            params: {
              id: String(poi.eventId)
            },
            query: {
              ...this.$route.query,
              poi_id: String(poiId),
              parent: String(parentId)
            }
          });

          return;
        }

        // POI normal: PoiDetails se ocupă și de afișarea pe hartă
        await this.$router.push({
          name: "poiDetails",
          params: {
            id: String(poiId)
          },
          query: {
            ...this.$route.query,
            parent: String(parentId)
          }
        });
      } catch (error) {
        if (error?.name !== "NavigationDuplicated") {
          console.error(error);
        }
      }
    },

    childCount(cat) {
      return cat.children.filter(c => c.type === "item").length;
    },
    getStyle(category) {
      if (category.style && category.style.fill_color) {
        return {background: category.style.fill_color};
      }
      return "";
    },
    reloadCategoryFor3D() {
      if (this.currentCategory) {
        this.updateCurrentCategory(this.currentCategory, null);
      }
    }
    // beforeDestroy() {
    //   this.$root.$off("forceCategoryReloadFor3D", this.reloadCategoryFor3D);
    // }
  }
};
</script>
